import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicPerson({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M10.68 8.92a.75.75 0 011-.37 4.97 4.97 0 013.07 4.8c0 1.3-.98 2.15-2.25 2.15h-9c-1.3 0-2.25-.8-2.25-2.15a4.98 4.98 0 013.1-4.8.75.75 0 01.64 1.36c-1.52.72-2.24 1.8-2.24 3.44 0 .46.23.65.75.65h9c.48 0 .75-.23.75-.65 0-1.64-.74-2.78-2.2-3.43a.75.75 0 01-.37-1zM8 .75a4.25 4.25 0 110 8.5 4.25 4.25 0 010-8.5zm0 1.5a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicPerson.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicPerson.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicPerson svgRef={ref} {...props} />);
export default ForwardRef;
